import { useState } from 'react';
import { useOnMount } from './useOnMount';

export function useEvent(
  eventName: string,
  options?: boolean | AddEventListenerOptions
) {
  const [event, setEvent] = useState<Event | null>(null);
  useOnMount(() => {
    window.addEventListener(eventName, setEvent, options);
    return () => window.removeEventListener(eventName, setEvent, options);
  });
  return event;
}
